import {
  LIST_SEGMENT_REQUEST,
  LIST_SEGMENT_SUCCESS,
  LIST_SEGMENT_ERROR,
} from '../../actions';

export const listSegmentRequest = () => ({
  type: LIST_SEGMENT_REQUEST,
});
export const listSegmentSuccess = (segments) => ({
  type: LIST_SEGMENT_SUCCESS,
  payload: segments,
});
export const listSegmentError = (message) => ({
  type: LIST_SEGMENT_ERROR,
  payload: { message },
});
